import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 14,
	viewBox: "0 0 11 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 6.1835C0.549061 6.1835 0.183503 6.54906 0.183503 7C0.183503 7.45094 0.549061 7.8165 1 7.8165V6.1835ZM10.5774 7.57735C10.8962 7.25849 10.8962 6.74151 10.5774 6.42265L5.3812 1.2265C5.06234 0.907635 4.54536 0.907635 4.2265 1.2265C3.90764 1.54536 3.90764 2.06234 4.2265 2.3812L8.8453 7L4.2265 11.6188C3.90764 11.9377 3.90764 12.4546 4.2265 12.7735C4.54536 13.0924 5.06234 13.0924 5.3812 12.7735L10.5774 7.57735ZM1 7.8165H10V6.1835H1V7.8165Z",
		fill: "#1F3171"
	})
});
export default SvgRightArrow;
